import {
  ReminderAttachment,
  ReminderRecipient,
  ReminderSender,
  ReminderTransport
} from "../reminder";

export enum Priority {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low"
}

export interface MessageCreate {
  recipients: ReminderRecipient[];
  attachments?: ReminderAttachment[];
  sender: ReminderSender;
  resources?: string[];
  transport: ReminderTransport;
  data?: string;
  subject: string;
  priority: Priority;
  description?: string;
  body?: string;
  templateId?: string;
}
